import { Button, Space, Tag, Tooltip } from "antd";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import { saveTaxCaseStatusToInProgress } from "../../../../services/taxService";
import _t from "../../../../lang/translate";
import StatusTag from "../../../../components/statusTag";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import openModal from "../../../../components/modal/openModal";
import { TaxCase } from "../../../../types/taxTypes";
import Icon from "../../../../assets/icons/icon";

export default function TaxCasePageTitleExtra() {
  const { taxCase, setTaxCase } = TaxCaseStore.useContainer()

  const handleStatusChange = async () => {
    try {
      const { id, status } = taxCase;
      const newCase = await openModal<TaxCase>("changeStatus", {
        id,
        context: "tax",
        initialValues: {
          id: status?.id,
          forcedStatus: taxCase.flags.forcedStatus,
        },
      });
      setTaxCase(newCase);
    } catch (error) {
    }
  };

  const handleCaseStatus = async () => {
    try {
      if (taxCase.isInProgress) return
      const data = await saveTaxCaseStatusToInProgress(taxCase.id);

      if (data) {
        setTaxCase(data.data);
        return true;
      }
    } catch (error) {
      renderErrorMessage(error)

      return false;
    }
  };


  return (
    <Space>
      <Tooltip title={"Sæt sagen igang"}>
        <Button onClick={handleCaseStatus} shape="circle"
          className={`btn-toggle-inProgress ${taxCase.isInProgress ? "inProgress" : ""}`}
          icon={<Icon name="hand"
            style={{ fontSize: 16 }}
          />}
        />
      </Tooltip>

      <StatusTag locked={taxCase.flags.forcedStatus} status={taxCase.status} onClick={handleStatusChange} />

      {taxCase.flags.isPriority && (
        <Tooltip title={_t("high_priority")}>
          <Icon name="lightning" className="text-warning" size="large" />
        </Tooltip>
      )}
    </Space>
  )
}
